import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormalizationService } from 'src/app/services/formalization/formalization.service';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  btnOneIcon:string,
  textBtnOne:string,
  textExtra:string,
  textLink:string,
  routerContentLink:string,
  infoBoxIcon:string,
  infoBoxSpan:string,
  infoBoxNumber:string,
  proposalCode:string,
}

@Component({
  selector: 'app-modal-redirect-bb',
  templateUrl: './modal-redirect-bb.component.html',
  styleUrls: ['./modal-redirect-bb.component.scss']
})
export class ModalRedirectBBComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalRedirectBBComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private route: Router,
    private formalization: FormalizationService
  ) { }

  ngOnInit(): void {
  }

  async onContinueClick() {
    await this.route.navigate(["formalizacao", this.data.proposalCode, "debito-em-conta", "aguardando-aprovacao"]);
    window.open(this.data.routerContentLink, '_blank')

    this.formalization.getStatusAuthorizedDebit()

  }

}
